// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "pdf-viewer" + "." + "0b38b4a7" + ".css";
};